function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
class Polyfills extends PureComponent {
    //to add a new polyfill just add a new script tag inside the fragment
    render() {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx("script", {
                dangerouslySetInnerHTML: {
                    __html: this.renderClosestPolyfill()
                }
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderClosestPolyfill", ()=>{
            return `
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                    Element.prototype.webkitMatchesSelector;
        }
        
      if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
          var el = this;
      
          do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
          } while (el !== null && el.nodeType === 1);
          return null;
        };
      }`;
        });
    }
}
export { Polyfills as default };
